import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import SocialLinks from '../components/SocialLinks';

export default function PublicLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <SocialLinks />
    </>
  );
}
